import React from "react";

const CheckoutSection = ({ title, children }) => (
  <section>
    <h2 className="mb-6 font-mono text-xs font-semibold uppercase tracking-[0.24em] text-zinc-400">
      <span className="text-cynos-red">{title.split(" / ")[0]} /</span> {title.split(" / ")[1]}
    </h2>
    <div className="space-y-4">{children}</div>
  </section>
);

export default CheckoutSection;
